import React, { useState, useEffect, useRef, useCallback } from "react";
import { ReactComponent as CardsIcon } from "../../assets/icons/cards.svg";
import CustomTitle from "../../components/UI/title/CustomTitle";
import "./trial.scss";
import { WithWizard } from "react-albus-react18";
import MyButton from "../../components/UI/button/MyButton";
import axios from "axios";
import Payment, {
    InitConfig,
    SdkMessage,
    ClientSdkInstance,
    MessageType,
} from "@solidgate/react-sdk";
import { Helmet } from "react-helmet";
import PriceInfo from "../../components/PriceInfo/PriceInfo";
import { useHistory } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import useOverflow from "../../hooks/useOverflow";
import useBlockClassName from "../../hooks/useBlockClassName";
import useFaceBook from "../../hooks/useFaceBook";
import { useDispatch } from "react-redux";

import useMixpanel from "../../hooks/useMixpanel";
import { PriceFunneleData } from "../Price/Price.consts";

const formParams = {
    allowSubmit: false,
    formTypeClass: "card",
    googleFontLink:
        "https://fonts.googleapis.com/css2?family=Public+Sans:ital@0;1&display=swap",
};

const Trial = ({
    setShowTermBundle,
    setButtonShow,
    setWhiteWrapper,
    setWelcometo,
    setTrialLoad,
    setEventProperties,
    sessionId,
    setEventName,
    setBlockStyle,
    time,
    setTime,
}) => {
    const history = useHistory();
    const { changeOverflow } = useOverflow();
    const { updateBlockClassName } = useBlockClassName();
    const { sendFb } = useFaceBook();
    const [isLoadingCard, setIsLoadingCard] = useState(false);
    const customerioSent = useRef(false);
    const dispatch = useDispatch();
    const { trackEvent, businessProfiles } = useMixpanel();

    const generatePromoCode = () => {
        let localName = null;

        try {
            const parsed = JSON.parse(localStorage.getItem("business-profiles"));
            localName = parsed?.[0]?.userName || null;
        } catch {
            localName = null;
        }

        const name =
            businessProfiles?.data?.userName ||
            localName ||
            "growth";

        const now = new Date();
        const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

        const month = monthNames[now.getMonth()];
        const year = now.getFullYear().toString().slice(-2);

        return `${name.toLowerCase()}_${month}${year}`;
    };
    useEffect(() => {
        const savedTime = localStorage.getItem("timerTime");
        if (savedTime && parseInt(savedTime, 10) !== time) {
            setTime(parseInt(savedTime, 10));
        }
    }, []);
    const intervalRef = useRef(null);
    useEffect(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }

        if (time <= 0) {
            return;
        }

        intervalRef.current = setInterval(() => {
            setTime((prev) => {
                const newTime = prev - 1;
                const finalTime = Math.max(0, newTime);

                if (finalTime > 0) {
                    localStorage.setItem("timerTime", finalTime.toString());
                } else {
                    localStorage.removeItem("timerTime");
                }

                return finalTime;
            });
        }, 1000);

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [time]);

    useEffect(() => {
        if (history.location.pathname === "/trial") {
            changeOverflow("hidden");

            setWelcometo(false);
            setWhiteWrapper(true);
            setButtonShow(false);

            const userAgent = navigator.userAgent.toLowerCase();
            const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

            const isApplePay =
                userAgent.includes("iphone") ||
                userAgent.includes("ipad") ||
                userAgent.includes("ipod") ||
                isSafari

            window.gtag('event', 'conversion', { 'send_to': 'AW-17610941807/BaJcCJjqoKsbEO_Kxs1B' });
            trackEvent("web_checkout_view", {
                payment_method: isApplePay ? "apple_pay, paypal, credit_card" : "paypal, credit_card",
            });
            sendFb("checkout_show", { onlyBq: true }, null, null, {
                object_value: isApplePay ? "apple_pay, paypal, credit_card" : "paypal, credit_card",
                event_properties: {
                    ...(PriceFunneleData[localStorage.getItem("price")] ||
                        PriceFunneleData["1"]),
                }
            });
        }
    }, [history.location]);

    const [isUSA, setIsUSA] = useState(true);

    useEffect(() => {
        // const fetchIPInfo = async () => {
        //     try {
        //         const response = await fetch('https://ipapi.co/json/');
        //         const data = await response.json();
        //         setIsUSA(data.country === 'US');
        //     } catch (error) {
        //         console.error('Error fetching IP info:', error);
        //     }
        // };
        // fetchIPInfo();
    }, []);

    const [yourPrice, setYourPrice] = useState("83.00");
    const [week, setWeek] = useState("4");
    const [discount, setDiscont] = useState("53.00");
    const [total, setTotal] = useState("29.95");
    const [precent, setPrecent] = useState("64");
    // const [price, setPrice] = useState('89.95');
    const [productId, setProductId] = useState(
        "438e21f4-8c27-4820-81b6-ff2461a46e92"
    );
    const [plan, setPlan] = useState("4-Week Plan");

    const [priceLocalStorage, setPriceLocalStorage] = useState(
        localStorage.getItem("price")
    );

    useEffect(() => {
        const handleStorageChange = () => {
            const newPrice = localStorage.getItem("price");
            if (newPrice !== priceLocalStorage) {
                setPriceLocalStorage(newPrice);
            }
            if (localStorage.getItem("price")) {
                if (localStorage.getItem("price") == "0") {
                    setWeek("2");
                    setYourPrice("42.00");
                    setDiscont("22.00");
                    setTotal("19.95");
                    setPrecent("54");
                    setProductId("683a6e64-90f6-426f-800a-81da5f795f11");
                    setPlan("2-Week Trial");
                }
                if (localStorage.getItem("price") == "1") {
                    setWeek("4");
                    setYourPrice("83.00");
                    setDiscont("53.00");
                    setTotal("29.95");
                    setPrecent("64");
                    setProductId("438e21f4-8c27-4820-81b6-ff2461a46e92");
                    setPlan("4-Week Plan");
                }
                if (localStorage.getItem("price") == "2") {
                    setWeek("8");
                    setYourPrice("167.00");
                    setDiscont("117.00");
                    setTotal("49.95");
                    setPrecent("70");
                    setProductId("557bcd7c-3b0d-4c17-a20d-01bff1726516");
                    setPlan("8-Week Plan");
                }
            }
        };

        window.addEventListener("storage", handleStorageChange);

        const interval = setInterval(() => {
            handleStorageChange();
        }, 1000);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
            clearInterval(interval);
        };
    }, []);

    const [buttonText, setButtonText] = useState("Pay with");
    const [buttonIcon, setButtonIcon] = useState("applePay");

    const [selectedMethod, setSelectedMethod] = useState("applePay"); // Default to 'applePay'

    const handleSelectMethod = (method) => {
        setSelectedMethod(method);
        if (method === "applePay") {
            setButtonText("Pay with");
            setButtonIcon("applePay");
        }
        if (method === "creditCard") {
            setButtonText("Pay  1.00  USD");
            setButtonIcon("");

        }
        trackEvent("web_checkout_click", {
            payment_method: method === "creditCard" ? "credit_card" : "paypal",
            ...(PriceFunneleData[localStorage.getItem("price")] ||
                PriceFunneleData["1"]),
        });
    };

    const [merchant, setMerchant] = useState("");
    const [signature, setSignature] = useState("");
    const [paymentIntent, setPaymentIntent] = useState("");
    const [scriptUrl, setScriptUrl] = useState("");
    const merchantData = {
        merchant: merchant,
        signature: signature,
        paymentIntent: paymentIntent,
    };

    const [currentProductId, setCurrentProductId] = useState("");

    useEffect(() => {
        if (currentProductId != productId) {
            setCurrentProductId(productId);
            if (localStorage.getItem("email")) {
                initSolidgate();
                initPaypal();
            }
        }
    }, [plan, productId]);

    const appleContainerRef = useRef(null);

    const [isMounted, setIsMounted] = useState(false);
    const [form, setForm] = useState(null);

    const handleOnReadyPaymentInstance = useCallback((form) => {
        setForm(form);
    }, []);

    const handleMounted = useCallback(() => {
        setIsMounted(true);
    }, []);

    const handleSubmit = useCallback(
        (event, method) => {
            if (method === "creditCard") {
                setIsLoadingCard(true);
            }

            trackEvent("web_checkout_click", {
                payment_method: method === "creditCard" ? "credit_card" : "apple_pay",
                ...(PriceFunneleData[localStorage.getItem("price")] ||
                    PriceFunneleData["1"]),
            });
            sendFb("checkout_click", { onlyBq: true }, null, null, {
                object_value: method === "creditCard" ? "credit_card" : "apple_pay",
                event_properties: {
                    ...(PriceFunneleData[localStorage.getItem("price")] ||
                        PriceFunneleData["1"]),
                    payment_method: method === "creditCard" ? "credit_card" : "apple_pay",
                }
            });
            localStorage.setItem(
                "web_pay_method",
                method === "creditCard" ? "credit_card" : "apple_pay"
            );
        },
        [plan]
    );

    const handleFail = useCallback(
        (event) => {
            trackEvent("web_purchase_error", {
                ...(PriceFunneleData[localStorage.getItem("price")] ||
                    PriceFunneleData["1"]),
                error_code: event || "",
                error_message_user: event || "",
            });
            sendFb("purchase_error", { onlyBq: true }, null, null, {
                event_properties: {
                    ...(PriceFunneleData[localStorage.getItem("price")] ||
                        PriceFunneleData["1"]),
                    order_id: event?.order?.order_id,
                },
                error_code: event || "",
                error_message_user: event || "",
            });
            setIsLoadingCard(false);
            handleSelectMethod("creditCard");
            setTimeout(() => {
                initSolidgate();
            }, 3000);
        },
        [productId]
    );

    async function hashData(data) {
        const encoder = new TextEncoder();
        const normalized = (data || "").trim().toLowerCase();
        const dataBuffer = encoder.encode(normalized);
        const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer);
        return Array.from(new Uint8Array(hashBuffer))
            .map((b) => b.toString(16).padStart(2, "0"))
            .join("");
    }

    const handleSuccess = useCallback(async (event) => {
        const fullJSON = localStorage.getItem("business-profiles");
        const profile = JSON.parse(fullJSON)[0];
        const trimmedJSON = JSON.stringify({
            name: profile.userName,
        });

        const data = trimmedJSON;
        const name = profile.userName;
        const email = localStorage.getItem("email");

        const hashedName = await hashData(name);
        const hashedEmail = await hashData(email);

        purchases();
        trackEvent("web_purchase", {
            payment_method: localStorage.getItem("web_pay_method"),
            order_id: event?.order.order_id,
            screen_id: 'trial',
            ...(PriceFunneleData[localStorage.getItem("price")] ||
                PriceFunneleData["1"]),
        });
        localStorage.setItem("productId", productId);

        if (localStorage.getItem("price")) {
            if (localStorage.getItem("price") == "0") {
                sendFb(
                    "Purchase",
                    {
                        custom_data: {
                            currency: "USD",
                            value: "100.00",
                        },
                    },
                    {
                        value: "100.00",
                        currency: "USD",
                        user_data: { fn: hashedName, em: hashedEmail },
                    },
                    {
                        orderId: event?.order.order_id,
                    },
                    {
                        object_value: localStorage.getItem("web_pay_method"),
                        order_id: event?.order.order_id,
                        event_properties: {
                            ...(PriceFunneleData[localStorage.getItem("price")] ||
                                PriceFunneleData["1"]),
                            payment_method: localStorage.getItem("web_pay_method"),
                        }
                    }
                );
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-17610941807/_ZjFCMm3kasbEO_Kxs1B',
                    'value': 19.95,
                    'currency': 'USD',
                    'transaction_id': event?.order.order_id
                });
            }
            if (localStorage.getItem("price") == "1") {
                sendFb(
                    "Purchase",
                    {
                        custom_data: {
                            currency: "USD",
                            value: "110.00",
                        },
                    },
                    {
                        value: "110.00",
                        currency: "USD",
                        user_data: { fn: hashedName, em: hashedEmail },
                    },
                    {
                        orderId: event?.order.order_id,
                    },
                    {
                        object_value: localStorage.getItem("web_pay_method"),
                        order_id: event?.order.order_id,
                        event_properties: {
                            ...(PriceFunneleData[localStorage.getItem("price")] ||
                                PriceFunneleData["1"]),
                            payment_method: localStorage.getItem("web_pay_method"),
                        }
                    }
                );
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-17610941807/_ZjFCMm3kasbEO_Kxs1B',
                    'value': 29.95,
                    'currency': 'USD',
                    'transaction_id': event?.order.order_id
                });
            }
            if (localStorage.getItem("price") == "2") {
                sendFb(
                    "Purchase",
                    {
                        custom_data: {
                            currency: "USD",
                            value: "120.00",
                        },
                    },
                    {
                        value: "120.00",
                        currency: "USD",
                        user_data: { fn: hashedName, em: hashedEmail },
                    },
                    {
                        orderId: event?.order.order_id,
                    },
                    {
                        object_value: localStorage.getItem("web_pay_method"),
                        order_id: event?.order.order_id,
                        event_properties: {
                            ...(PriceFunneleData[localStorage.getItem("price")] ||
                                PriceFunneleData["1"]),
                            payment_method: localStorage.getItem("web_pay_method"),
                        }
                    }
                );
                window.gtag('event', 'conversion', {
                    'send_to': 'AW-17610941807/_ZjFCMm3kasbEO_Kxs1B',
                    'value': 49.95,
                    'currency': 'USD',
                    'transaction_id': event?.order.order_id
                });
            }
        }

        const params = new URLSearchParams(window.location.search);
        history.push({
            pathname: "/loader",
            search: `?${params.toString()}`,
        });
    }, []);

    const initSolidgate = useCallback(() => {
        console.log("init solidgate");
        setTrialLoad(true);
        axios
            .post("https://staging.zeely.link/stripe/solidgate", {
                email: localStorage.getItem("email"),
                productId: productId,
                metadata: {
                    funnel: process.env.REACT_APP_FUNNEL,
                    // paymentUrl: window.location.href,
                },
            })
            .then((response) => {
                if (response) {
                    setMerchant(response.data.merchant);
                    setSignature(response.data.signature);
                    setPaymentIntent(response.data.paymentIntent);
                    console.log(productId);
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error);
                // Handle error here
            });
    }, [productId]);

    const initPaypal = useCallback(() => {
        // const fullJSON = localStorage.getItem('business-profiles');
        // const profile = JSON.parse(fullJSON)[0];

        axios
            .post("https://staging.zeely.link/subscriptions/solidgate/init", {
                email: localStorage.getItem("email"),
                productId: productId,
                metadata: {
                    funnel: process.env.REACT_APP_FUNNEL,
                    // paymentUrl: window.location.href,
                },
            })
            .then((response) => {
                if (response) {
                    localStorage.setItem("orderIdPaypal", response.data.orderId);
                    setScriptUrl(response.data.scriptUrl);
                }
                setTrialLoad(false);
            })
            .catch((error) => {
                console.error("An error occurred:", error);
                setTrialLoad(false);
                // Handle error here
            });
    }, [productId]);

    const styles = {
        form_body: {
            width: "100%",
            "min-width": "0",
        },
        card_view: {
            background: "#fff",
            "box-shadow": "none",
            "border-radius": "0",
            padding: "0",
            "margin-bottom": "0px",
            ".brand-icon": {
                display: "none",
            },
        },
        card_number: {
            ".error input": {
                "border-color": "#FC9494",
                color: "#FC9494",
            },
            ".error .label": {
                color: "#FC9494!important",
            },
            ".error-text": {
                color: "#FC9494",
                position: "absolute",
                background: "#ffffff",
            },
            input: {
                background: "transparent!important",
                "font-family": '"Public Sans", sans-serif!important',
                border: "none",
                "font-weight": " 400!important",
                "text-transform": "uppercase",
                color: "#000!important",
                width: "100%",
                padding: "0!important",
                height: "17px",
                "font-size": "14px!important",
                "border-radius": "0",
                "::placeholder": {
                    "font-size": "14px!important",
                    color: "#A7A8AA!important",
                },
            },
            ".input-block": {
                border: "1px solid #F2F4F6",
                "border-radius": "11px",
                padding: "24px 16px 8px",
            },
            ".label": {
                "font-family": '"Public Sans", sans-serif!important',
                "font-weight": "400",
                color: "#000!important",
                left: "16px",
                top: "8px",
                "padding-left": "0",
                "font-size": "10px!important",
                "line-height": "10px",
                opacity: "1!important",
            },
        },
        card_cvv: {
            ".error input": {
                "border-color": "#FC9494",
                color: "#FC9494",
            },
            ".error .label": {
                color: "#FC9494!important",
            },
            ".error-text": {
                color: "#FC9494",
                position: "absolute",
                background: "#ffffff",
            },
            input: {
                background: "transparent!important",
                "font-family": '"Public Sans", sans-serif!important',
                border: "none",
                "font-weight": " 400!important",
                "text-transform": "uppercase",
                color: "#000!important",
                width: "100%",
                padding: "0!important",
                height: "17px",
                "font-size": "14px!important",
                "border-radius": "0",
                "::placeholder": {
                    "font-size": "14px!important",
                    color: "#A7A8AA!important",
                },
            },
            ".input-block": {
                border: "1px solid #F2F4F6",
                "border-radius": "11px",
                padding: "24px 16px 8px",
            },
            ".label": {
                "font-family": '"Public Sans", sans-serif!important',
                "font-weight": "400",
                color: "#000!important",
                left: "16px",
                top: "8px",
                "padding-left": "0",
                "font-size": "10px!important",
                "line-height": "10px",
                opacity: "1!important",
            },
            ".tooltip": {
                width: "136px",
                "min-height": "56px",
                top: "auto",
                bottom: "3em",
                img: {
                    width: "100px",
                },
                "::after": {
                    top: "auto",
                    bottom: "-17px",
                    right: "calc(0.9em + -23px)",
                    transform: "rotate(-225deg)",
                },
            },
            ".tooltip-icon": {
                "::before": {
                    "background-color": "#ABABAB",
                    color: "#fff",
                },
            },
        },
        expiry_date: {
            ".error input": {
                "border-color": "#FC9494",
                color: "#FC9494",
            },
            ".error .label": {
                color: "#FC9494!important",
            },
            ".error-text": {
                color: "#FC9494",
                position: "absolute",
                background: "#ffffff",
            },
            input: {
                background: "transparent!important",
                "font-family": '"Public Sans", sans-serif!important',
                border: "none",
                "font-weight": " 400!important",
                "text-transform": "uppercase",
                color: "#000!important",
                width: "100%",
                padding: "0!important",
                height: "17px",
                "font-size": "14px!important",
                "border-radius": "0",
                "::placeholder": {
                    "font-size": "14px!important",
                    color: "#A7A8AA!important",
                },
            },
            ".input-block": {
                border: "1px solid #F2F4F6",
                "border-radius": "11px",
                padding: "24px 16px 8px",
            },
            ".label": {
                "font-family": '"Public Sans", sans-serif!important',
                "font-weight": "400",
                color: "#000!important",
                left: "16px",
                top: "8px",
                "padding-left": "0",
                "font-size": "10px!important",
                "line-height": "10px",
                opacity: "1!important",
            },
        },
    };

    const [platfrom, setPlatfrom] = useState("");

    const isApplePayAvailable = () => {
        if (window.ApplePaySession) {
            return true;
        } else {
            return true;
        }
    };

    useEffect(() => {
        if (isApplePayAvailable()) {
            setSelectedMethod("applePay");
            setPlatfrom("iOS");
        } else {
            setSelectedMethod("creditCard");
            setPlatfrom("");
        }
    }, []);

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
        if (userAgent.includes("android")) {
            setPlatfrom("Android");
            if (!isUSA) {
                setSelectedMethod("creditCard");
            } else {
                setSelectedMethod("applePay");
            }
        } else if (
            userAgent.includes("iphone") ||
            userAgent.includes("ipad") ||
            userAgent.includes("ipod") ||
            isSafari
        ) {
            setPlatfrom("iOS");
        } else {
            setPlatfrom("");
            if (!isUSA) {
                setSelectedMethod("creditCard");
            } else {
                setSelectedMethod("applePay");
            }
        }
    }, [isUSA]);

    const initialOptions = {
        "client-id": "YOUR-CLIENT-ID-HERE",
        currency: "USD",
        intent: "capture",
    };

    const [showErrors, setShowErrors] = useState(false);

    useEffect(() => {
        const script = document.createElement("script");

        script.src = scriptUrl;
        script.async = true;

        document.body.appendChild(script);

        script.onload = () => {
            const elem = document.getElementById("paypal-button");
            const handleOrderStartedProcessing = (e) => {
                console.log("order-started-processing", e);
            };
            const handleOrderProcessed = async (e) => {
                const fullJSON = localStorage.getItem("business-profiles");
                const profile = JSON.parse(fullJSON)[0];
                const trimmedJSON = JSON.stringify({
                    name: profile.userName,
                });

                const data = trimmedJSON;
                const name = profile.userName;
                const email = localStorage.getItem("email");

                const hashedName = await hashData(name);
                const hashedEmail = await hashData(email);


                console.log("order-processed", e);
                if (e.detail.data.error) {
                    console.log("Error:", e.detail.data.error);
                    trackEvent("web_purchase_error", {
                        ...(PriceFunneleData[localStorage.getItem("price")] ||
                            PriceFunneleData["1"]),
                        error_code: e.detail.data.error?.code || "",
                        error_message_user: e.detail.data.error?.message || "",
                    });
                    sendFb("purchase_error", { onlyBq: true }, null, null, {
                        event_properties: {
                            ...(PriceFunneleData[localStorage.getItem("price")] ||
                                PriceFunneleData["1"]),
                            order_id: localStorage.getItem("orderIdPaypal"),
                        },
                        error_code: e.detail.data.error?.code || "",
                        error_message_user: e.detail.data.error?.message || "",

                    });
                    setShowErrors(true);
                    setTimeout(() => {
                        setShowErrors(false);
                    }, 2000);
                } else {
                    if (e.detail.data.order.status) {

                        sendFb("checkout_click", { onlyBq: true }, null, null, {
                            object_value: "paypal",
                            event_properties: {
                                ...(PriceFunneleData[localStorage.getItem("price")] ||
                                    PriceFunneleData["1"]),
                                payment_method: "paypal",
                            }
                        });
                        localStorage.setItem("web_pay_method", "paypal");
                        if (e.detail.data.order.status === "approved") {
                            purchases();

                            trackEvent("web_purchase", {
                                payment_method: "paypal",
                                order_id: localStorage.getItem("orderIdPaypal"),
                                screen_id: 'trial',
                                ...(PriceFunneleData[localStorage.getItem("price")] ||
                                    PriceFunneleData["1"]),
                            });
                            localStorage.setItem("productId", productId);

                            const purcheaseOrderIdsKey = "purcheaseOrderIds";
                            let purcheaseOrderIds = JSON.parse(
                                sessionStorage.getItem(purcheaseOrderIdsKey) || "[]"
                            );
                            const isHaveOrderId = localStorage.getItem("orderIdPaypal") && purcheaseOrderIds.includes(localStorage.getItem("orderIdPaypal"))

                            if (localStorage.getItem("orderIdPaypal")) {
                                purcheaseOrderIds.push(localStorage.getItem("orderIdPaypal"));
                                sessionStorage.setItem(
                                    purcheaseOrderIdsKey,
                                    JSON.stringify(purcheaseOrderIds)
                                );
                            }


                            if (localStorage.getItem("price")) {
                                if (localStorage.getItem("price") == "0") {
                                    sendFb(
                                        "Purchase",
                                        {
                                            custom_data: {
                                                currency: "USD",
                                                value: "100.00",
                                            },
                                        },
                                        {
                                            value: "100.00",
                                            currency: "USD",
                                            user_data: { fn: hashedName, em: hashedEmail },
                                        },
                                        {
                                            orderId: localStorage.getItem("orderIdPaypal"),
                                        },
                                        {
                                            object_value: "paypal",
                                            order_id: localStorage.getItem("orderIdPaypal"),
                                            event_properties: {
                                                ...(PriceFunneleData[localStorage.getItem("price")] ||
                                                    PriceFunneleData["1"]),
                                                payment_method: "paypal",
                                            }
                                        }
                                    );
                                    if (!isHaveOrderId) {
                                        window.gtag('event', 'conversion', {
                                            'send_to': 'AW-17610941807/_ZjFCMm3kasbEO_Kxs1B',
                                            'value': 19.95,
                                            'currency': 'USD',
                                            'transaction_id': localStorage.getItem('orderIdPaypal')
                                        });
                                    }

                                }
                                if (localStorage.getItem("price") == "1") {
                                    sendFb(
                                        "Purchase",
                                        {
                                            custom_data: {
                                                currency: "USD",
                                                value: "110.00",
                                            },
                                        },
                                        {
                                            value: "110.00",
                                            currency: "USD",
                                            user_data: { fn: hashedName, em: hashedEmail },
                                        },
                                        {
                                            orderId: localStorage.getItem("orderIdPaypal"),
                                        },
                                        {
                                            object_value: "paypal",
                                            order_id: localStorage.getItem("orderIdPaypal"),
                                            event_properties: {
                                                ...(PriceFunneleData[localStorage.getItem("price")] ||
                                                    PriceFunneleData["1"]),
                                                payment_method: "paypal",
                                            }
                                        }
                                    );
                                    if (!isHaveOrderId) {
                                        window.gtag('event', 'conversion', {
                                            'send_to': 'AW-17610941807/_ZjFCMm3kasbEO_Kxs1B',
                                            'value': 29.95,
                                            'currency': 'USD',
                                            'transaction_id': localStorage.getItem('orderIdPaypal')
                                        });
                                    }

                                }
                                if (localStorage.getItem("price") == "2") {
                                    sendFb(
                                        "Purchase",
                                        {
                                            custom_data: {
                                                currency: "USD",
                                                value: "120.00",
                                            },
                                        },
                                        {
                                            value: "120.00",
                                            currency: "USD",
                                            user_data: { fn: hashedName, em: hashedEmail },
                                        },
                                        {
                                            orderId: localStorage.getItem("orderIdPaypal"),
                                        },
                                        {
                                            object_value: "paypal",
                                            order_id: localStorage.getItem("orderIdPaypal"),
                                            event_properties: {
                                                ...(PriceFunneleData[localStorage.getItem("price")] ||
                                                    PriceFunneleData["1"]),
                                                payment_method: "paypal",
                                            }
                                        }
                                    );
                                    if (!isHaveOrderId) {
                                        window.gtag('event', 'conversion', {
                                            'send_to': 'AW-17610941807/_ZjFCMm3kasbEO_Kxs1B',
                                            'value': 49.95,
                                            'currency': 'USD',
                                            'transaction_id': localStorage.getItem('orderIdPaypal')
                                        });
                                    }
                                }
                            }
                            const params = new URLSearchParams(window.location.search);
                            history.push({
                                pathname: "/loader",
                                search: `?${params.toString()}`,
                            });
                        }
                    }
                }
            };

            const handleOrderAlreadyProcessed = (e) => {
                console.log("order-already-processed", e);
            };

            const handleButtonReady = (e) => {
                console.log("button-ready", e);
            };

            const handleButtonError = (e) => {
                console.log("button-error", e);
            };

            const handleButtonClick = (e) => {
                trackEvent("web_checkout_click", {
                    payment_method: "paypal",
                    ...(PriceFunneleData[localStorage.getItem("price")] ||
                        PriceFunneleData["1"]),
                });
            };

            elem.addEventListener(
                "order-started-processing",
                handleOrderStartedProcessing
            );
            elem.addEventListener("order-processed", handleOrderProcessed);
            elem.addEventListener(
                "order-already-processed",
                handleOrderAlreadyProcessed
            );
            elem.addEventListener("button-ready", handleButtonReady);
            elem.addEventListener("button-click", handleButtonClick);
            elem.addEventListener("button-error", handleButtonError);
            return () => {
                elem.removeEventListener(
                    "order-started-processing",
                    handleOrderStartedProcessing
                );
                elem.removeEventListener("order-processed", handleOrderProcessed);
                elem.removeEventListener(
                    "order-already-processed",
                    handleOrderAlreadyProcessed
                );
                elem.removeEventListener("button-ready", handleButtonReady);
                elem.removeEventListener("button-click", handleButtonClick);
                elem.removeEventListener("button-error", handleButtonError);
            };
        };
        return () => {
            document.body.removeChild(script);
        };
    }, [scriptUrl]);

    const [checkboxes, setCheckboxes] = useState({
        Facebook: false,
    });
    const [error, setError] = useState(false);
    const areAllCheckboxesUnchecked = () => {
        return Object.values(checkboxes).every((isChecked) => !isChecked);
    };

    const [promocode, setPromocode] = useState("");
    const [promocodeCurrent, setPromocodeCurrent] = useState("");

    const handleInputChange = (event) => {
        setPromocode(event.target.value);
        if (event.target.value == "") {
            setCheckboxes({ F: false });
        } else {
            setCheckboxes({ F: true });
        }
    };

    const [buttonStatus, setButtonStatus] = useState("");

    const [showPromocodePopup, setShowPromocodePopup] = useState(false);
    const handleClick = () => {
        if (areAllCheckboxesUnchecked()) {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 1000);
        } else {
            setError(false);
            setButtonStatus("load");

            setTimeout(() => {
                setPromocodeCurrent(promocode);
                setShowPromocodePopup(false);
            }, 2000);
        }
    };

    const purchases = () => {
        const data = {
            pageId: "v1",
        };
        axios
            .post("https://staging.zeely.link/pages/purchases ", data, {
                headers: {
                    "Content-Type": "application/json",
                },
                redirect: "follow",
            })
            .then((response) => { })
            .catch((error) => { });
    };

    return (
        <>
            <div className="trial-timer">
                <div className="trial-timer__content">
                    <div className="trial-timer__icon">⏰</div>
                    <div className="trial-timer__text">
                        <span>Your discount reserved for</span>
                        <div className="trial-timer__time">
                            <span className="trial-timer__minutes">
                                {Math.floor(time / 60)
                                    .toString()
                                    .padStart(2, "0")}
                            </span>
                            <span className="trial-timer__colon">:</span>
                            <span className="trial-timer__seconds">
                                {(time % 60).toString().padStart(2, "0")}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{ height: "calc(100% - 35rem - 24rem)", display: "flex", flexDirection: "column" }}
                className="trial"
            >
                <Helmet>
                    <meta name="theme-color" content="#fff"></meta>
                </Helmet>



                <CustomTitle
                    style={{ marginBottom: "24rem" }}
                    title="Select payment method"
                />
                {/* <p style={{ marginBottom: "24px" }} className="text">
                It's important for us to keep your account
                secure in very safe place
            </p> */}

                {(isUSA || platfrom == "iOS") && (
                    <div className="trial-method__options">
                        <div
                            className={`trial-method__option ${selectedMethod === "applePay"
                                ? "trial-method__option--active"
                                : ""
                                }`}
                            onClick={() => handleSelectMethod("applePay")}
                        >
                            {isUSA && (
                                <svg
                                    style={{ marginBottom: platfrom == "iOS" ? "8rem" : "" }}
                                    width="76"
                                    height="20"
                                    viewBox="0 0 76 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_9469_25891)">
                                        <path
                                            d="M24.4031 4.00195C24.2479 4.00195 24.116 4.11467 24.0917 4.26814L22.2945 15.6654C22.288 15.707 22.2906 15.7495 22.3021 15.7901C22.3135 15.8306 22.3337 15.8682 22.3611 15.9002C22.3885 15.9323 22.4224 15.958 22.4607 15.9756C22.499 15.9932 22.5406 16.0024 22.5828 16.0024H24.7141C24.8691 16.0024 25.0012 15.8894 25.0255 15.7362L25.5534 12.3893C25.5775 12.2361 25.7096 12.1231 25.8648 12.1231H27.8026C30.0666 12.1231 31.9886 10.4712 32.3396 8.23272C32.6936 5.97533 30.9301 4.00685 28.4305 4.00195H24.4031ZM26.475 6.54625H28.0253C29.3017 6.54625 29.7174 7.29938 29.586 8.13226C29.4545 8.96692 28.809 9.58172 27.5743 9.58172H25.9963L26.475 6.54625ZM36.6744 7.32099C36.1363 7.32299 35.517 7.43326 34.8218 7.72284C33.2271 8.38753 32.4613 9.76126 32.136 10.7628C32.136 10.7628 31.1009 13.8183 33.4396 15.497C33.4396 15.497 35.6086 17.113 38.0502 15.3974L38.0081 15.6654C38.0015 15.707 38.0041 15.7495 38.0155 15.79C38.027 15.8305 38.0471 15.868 38.0744 15.9001C38.1018 15.9321 38.1357 15.9578 38.1739 15.9755C38.2122 15.9931 38.2537 16.0023 38.2959 16.0024H40.3191C40.4744 16.0024 40.6063 15.8894 40.6305 15.7362L41.8613 7.93133C41.8679 7.88971 41.8654 7.84714 41.8539 7.80657C41.8425 7.766 41.8224 7.72839 41.7951 7.69632C41.7677 7.66425 41.7338 7.63848 41.6955 7.6208C41.6572 7.60311 41.6156 7.59392 41.5735 7.59386H39.5502C39.3949 7.59386 39.2628 7.7068 39.2388 7.86005L39.1726 8.28017C39.1726 8.28017 38.2892 7.31497 36.6744 7.32099ZM36.7406 9.78621C36.9729 9.78621 37.1854 9.81828 37.3761 9.87954C38.2491 10.1598 38.744 10.9984 38.6008 11.9075C38.4242 13.0268 37.5062 13.851 36.3289 13.851C36.0968 13.851 35.8843 13.8192 35.6934 13.7579C34.8207 13.4777 34.3226 12.639 34.4658 11.73C34.6425 10.6106 35.5633 9.78621 36.7406 9.78621Z"
                                            fill="#003087"
                                        />
                                        <path
                                            d="M53.5379 4.00195C53.3826 4.00195 53.2508 4.11467 53.2265 4.26814L51.4293 15.6654C51.4228 15.707 51.4253 15.7495 51.4368 15.7901C51.4483 15.8306 51.4684 15.8682 51.4958 15.9002C51.5232 15.9323 51.5572 15.958 51.5955 15.9756C51.6338 15.9932 51.6754 16.0024 51.7176 16.0024H53.8489C54.0039 16.0024 54.136 15.8894 54.1603 15.7362L54.6882 12.3893C54.7123 12.2361 54.8444 12.1231 54.9996 12.1231H56.9373C59.2014 12.1231 61.1231 10.4712 61.474 8.23272C61.8281 5.97533 60.0648 4.00685 57.5653 4.00195H53.5379ZM55.6097 6.54625H57.1601C58.4365 6.54625 58.8521 7.29938 58.7207 8.13226C58.5893 8.96692 57.944 9.58172 56.709 9.58172H55.131L55.6097 6.54625ZM65.809 7.32099C65.2708 7.32299 64.6515 7.43326 63.9563 7.72284C62.3616 8.38753 61.5958 9.76126 61.2706 10.7628C61.2706 10.7628 60.2359 13.8183 62.5746 15.497C62.5746 15.497 64.7431 17.113 67.1849 15.3974L67.1428 15.6654C67.1363 15.707 67.1389 15.7495 67.1503 15.7901C67.1618 15.8306 67.182 15.8682 67.2093 15.9002C67.2367 15.9323 67.2707 15.958 67.309 15.9756C67.3473 15.9932 67.3889 16.0024 67.4311 16.0024H69.4541C69.6094 16.0024 69.7413 15.8894 69.7655 15.7362L70.9967 7.93133C71.0033 7.88967 71.0008 7.84707 70.9893 7.80647C70.9779 7.76586 70.9578 7.72823 70.9304 7.69615C70.903 7.66407 70.8689 7.63832 70.8306 7.62066C70.7923 7.603 70.7506 7.59386 70.7085 7.59386H68.6852C68.5299 7.59386 68.3978 7.7068 68.3738 7.86005L68.3076 8.28017C68.3076 8.28017 67.4237 7.31497 65.809 7.32099ZM65.8751 9.78621C66.1075 9.78621 66.32 9.81828 66.5107 9.87954C67.3836 10.1598 67.8786 10.9984 67.7354 11.9075C67.5587 13.0268 66.6407 13.851 65.4635 13.851C65.2314 13.851 65.0189 13.8192 64.828 13.7579C63.9552 13.4777 63.4571 12.639 63.6004 11.73C63.777 10.6106 64.6979 9.78621 65.8751 9.78621Z"
                                            fill="#0070E0"
                                        />
                                        <path
                                            d="M42.8209 7.59397C42.6605 7.59397 42.5465 7.75057 42.5955 7.90316L44.8136 14.7865L42.808 18.0302C42.7106 18.1877 42.8238 18.3911 43.0089 18.3911H45.3794C45.4472 18.391 45.5139 18.3735 45.5729 18.3402C45.6319 18.3068 45.6814 18.2589 45.7165 18.2009L51.9115 7.95261C52.0066 7.79512 51.893 7.59375 51.709 7.59375H49.3387C49.2702 7.59381 49.203 7.61169 49.1435 7.64563C49.0841 7.67957 49.0345 7.7284 48.9996 7.78732L46.5611 11.9043L45.3233 7.81784C45.283 7.68486 45.1603 7.59375 45.0215 7.59375L42.8209 7.59397Z"
                                            fill="#003087"
                                        />
                                        <path
                                            d="M73.2962 4.00195C73.1412 4.00195 73.0091 4.11489 72.9848 4.26814L71.1872 15.6649C71.1806 15.7066 71.1831 15.7492 71.1946 15.7898C71.206 15.8304 71.2261 15.868 71.2535 15.9001C71.2809 15.9322 71.3149 15.9579 71.3532 15.9756C71.3916 15.9932 71.4332 16.0024 71.4754 16.0024H73.6067C73.7618 16.0024 73.8939 15.8894 73.9182 15.7362L75.7153 4.33898C75.7219 4.29738 75.7193 4.25487 75.7079 4.21435C75.6964 4.17384 75.6763 4.13628 75.649 4.10427C75.6216 4.07225 75.5877 4.04652 75.5494 4.02886C75.5112 4.0112 75.4696 4.00202 75.4275 4.00195H73.2962Z"
                                            fill="#0070E0"
                                        />
                                        <path
                                            d="M6.63453 4.00195C6.49724 4.00207 6.36449 4.05114 6.26013 4.14035C6.15577 4.22956 6.08663 4.35307 6.06517 4.48867L5.11914 10.4888C5.16325 10.2085 5.4047 10.0021 5.68849 10.0021H8.46067C11.2507 10.0021 13.6181 7.96675 14.0507 5.20861C14.0829 5.00269 14.1011 4.79484 14.1053 4.58646C13.3962 4.21468 12.5633 4.00195 11.6507 4.00195H6.63453Z"
                                            fill="#001C64"
                                        />
                                        <path
                                            d="M14.1039 4.58594C14.0998 4.79431 14.0815 5.00217 14.0493 5.20809C13.6167 7.96623 11.2491 10.0015 8.45932 10.0015H5.68715C5.40358 10.0015 5.1619 10.2078 5.11779 10.4883L4.24793 16.0019L3.70308 19.4608C3.69245 19.5276 3.69643 19.596 3.71477 19.6611C3.73311 19.7262 3.76538 19.7866 3.80932 19.8381C3.85326 19.8895 3.90784 19.9308 3.9693 19.9591C4.03076 19.9875 4.09763 20.0021 4.1653 20.0021H7.17426C7.31155 20.002 7.4443 19.9529 7.54866 19.8637C7.65302 19.7745 7.72214 19.651 7.74361 19.5154L8.53617 14.4885C8.55765 14.3528 8.62684 14.2292 8.73129 14.14C8.83575 14.0508 8.96861 14.0018 9.10598 14.0018H10.8775C13.6675 14.0018 16.035 11.9664 16.4676 9.20831C16.7747 7.25074 15.7888 5.46938 14.1039 4.58594Z"
                                            fill="#0070E0"
                                        />
                                        <path
                                            d="M3.21566 0.00195312C2.9321 0.00195312 2.69041 0.208224 2.64631 0.488225L0.285108 15.4609C0.240335 15.7451 0.459976 16.0022 0.747774 16.0022H4.24924L5.11866 10.4885L6.06468 4.48844C6.08615 4.35284 6.15529 4.22933 6.25965 4.14012C6.36401 4.05091 6.49675 4.00184 6.63405 4.00173H11.6502C12.5631 4.00173 13.3958 4.21468 14.1048 4.58623C14.1533 2.07513 12.0813 0.00195312 9.23247 0.00195312H3.21566Z"
                                            fill="#003087"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_9469_25891">
                                            <rect width="76" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            )}

                            {platfrom == "iOS" && (
                                <svg
                                    width="42"
                                    height="20"
                                    viewBox="0 0 42 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g clip-path="url(#clip0_7989_67295)">
                                        <path
                                            d="M20.7653 3.33203C23.1559 3.33203 24.8036 5.09059 24.8036 7.60773C24.8036 10.1594 23.1236 11.9179 20.7006 11.9179H18.0838V16.366H16.1777V3.33203H20.7653ZM18.0838 10.2283H20.2484C21.896 10.2283 22.8329 9.26285 22.8329 7.64222C22.8329 5.9871 21.896 5.05611 20.2484 5.05611H18.0515V10.2283H18.0838ZM25.2882 13.711C25.2882 12.0558 26.4835 11.0214 28.6157 10.8835L31.071 10.7455V10.0214C31.071 8.95251 30.3926 8.33185 29.2942 8.33185C28.2281 8.33185 27.5819 8.88355 27.4204 9.7111H25.6758C25.7728 7.98703 27.1619 6.71122 29.3588 6.71122C31.5233 6.71122 32.9125 7.91807 32.9125 9.84903V16.4005H31.1679V14.8488H31.1356C30.6187 15.9178 29.488 16.5729 28.325 16.5729C26.5158 16.5729 25.2882 15.4005 25.2882 13.711ZM31.071 12.8489V12.0903L28.8742 12.2283C27.7758 12.2972 27.1619 12.8144 27.1619 13.642C27.1619 14.4695 27.8081 15.0213 28.7773 15.0213C30.0695 15.0213 31.071 14.0903 31.071 12.8489ZM34.5278 19.9176V18.3315C34.657 18.366 34.9801 18.366 35.1093 18.366C35.9493 18.366 36.4016 17.9867 36.6923 17.0212C36.6923 16.9867 36.8539 16.435 36.8539 16.435L33.6232 6.9181H35.5939L37.8554 14.6764H37.8877L40.1491 6.9181H42.0875L38.76 16.9522C37.9846 19.2625 37.1123 19.9866 35.2709 19.9866C35.1416 19.9521 34.6893 19.9521 34.5278 19.9176Z"
                                            fill="black"
                                        />
                                        <path
                                            d="M8.10684 3.60173C8.63542 2.94145 8.99213 2.02384 8.89512 1.10938C8.13129 1.14164 7.20781 1.63508 6.66396 2.29299C6.17128 2.87692 5.74506 3.81185 5.86269 4.70821C6.71208 4.77589 7.57827 4.262 8.10684 3.60173ZM10.3013 9.40488C10.2845 7.42721 11.8672 6.47576 11.9405 6.42854C11.0476 5.09068 9.66278 4.90496 9.16934 4.8845C7.98921 4.76409 6.86408 5.60064 6.26752 5.60064C5.66868 5.60064 4.74749 4.90338 3.76672 4.92463C2.48042 4.94352 1.29418 5.69508 0.631934 6.88105C-0.700961 9.27582 0.293555 12.8125 1.59513 14.7492C2.23217 15.6975 2.9899 16.7631 3.98823 16.7245C4.94914 16.686 5.30967 16.0839 6.47071 16.0839C7.62945 16.0824 7.95713 16.723 8.96922 16.7049C10.0019 16.682 10.6573 15.7369 11.2905 14.7839C12.0185 13.686 12.3202 12.6197 12.3354 12.5662C12.3148 12.552 10.3243 11.7697 10.3013 9.40488Z"
                                            fill="black"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7989_67295">
                                            <rect width="41.9984" height="19.9993" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            )}

                            <div className={`trial-method__option-check ${selectedMethod === "applePay" && 'active'}`}>
                                <span></span>
                            </div>

                        </div>

                        <div
                            className={`trial-method__option ${selectedMethod === "creditCard"
                                ? "trial-method__option--active"
                                : ""
                                }`}
                            onClick={() => handleSelectMethod("creditCard")}
                        >
                            Credit Card
                            <div className="trial-method__cards">
                                <img
                                    className="ai-clip-animation-img img-1"
                                    src={`${process.env.REACT_APP_BASENAME}/img/Pay.svg`}
                                    alt=""
                                />




                            </div>

                            <div className={`trial-method__option-check ${selectedMethod === "creditCard" && 'active'}`}>
                                <span></span>
                            </div>

                        </div>
                    </div>
                )}

                <div className="trial-line">
                    <span>Your {week}-week plan with AI promotion tools</span>
                    <strong>{yourPrice} USD</strong>
                </div>
                <div className="trial-line" style={{ position: "relative" }}>
                    <span>
                        <PriceInfo
                            sessionId={sessionId}
                            eventName={"web_checkout_info_click"}
                            BQEvent={"info_button_click"}
                            setShowTermBundle={setShowTermBundle}
                            text={`${precent}% price discount`}
                        />
                    </span>
                    <strong className="red">- {discount} USD</strong>
                </div>

                <div className="trial-line">
                    <span>Applied promo code:</span>
                    <div className="trial-line__promo-code">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                        >
                            <path
                                d="M2.99303 4.87995C2.99303 3.83912 3.83637 2.99578 4.8772 2.99495H5.7347C6.2322 2.99495 6.70887 2.79745 7.0622 2.44745L7.66137 1.84745C8.39553 1.10912 9.58886 1.10578 10.3272 1.83995L10.328 1.84078L10.3355 1.84745L10.9355 2.44745C11.2889 2.79828 11.7655 2.99495 12.263 2.99495H13.1197C14.1605 2.99495 15.0047 3.83828 15.0047 4.87995V5.73578C15.0047 6.23328 15.2014 6.71078 15.5522 7.06412L16.1522 7.66411C16.8905 8.39828 16.8947 9.59161 16.1605 10.3299L16.1597 10.3308L16.1522 10.3383L15.5522 10.9383C15.2014 11.2908 15.0047 11.7674 15.0047 12.2649V13.1224C15.0047 14.1633 14.1614 15.0066 13.1205 15.0066H13.1197H12.2614C11.7639 15.0066 11.2864 15.2041 10.9339 15.5549L10.3339 16.1541C9.60053 16.8924 8.40803 16.8966 7.6697 16.1641C7.66887 16.1633 7.66803 16.1624 7.6672 16.1616L7.6597 16.1541L7.06053 15.5549C6.70803 15.2041 6.23053 15.0074 5.73303 15.0066H4.8772C3.83637 15.0066 2.99303 14.1633 2.99303 13.1224V12.2633C2.99303 11.7658 2.79553 11.2891 2.4447 10.9366L1.84553 10.3366C1.1072 9.60328 1.10303 8.41078 1.83637 7.67245C1.83637 7.67162 1.8372 7.67078 1.83803 7.66995L1.84553 7.66245L2.4447 7.06245C2.79553 6.70912 2.99303 6.23245 2.99303 5.73412V4.87995"
                                stroke="#8F969C"
                                stroke-width="1.52381"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M6.85938 11.1432L11.1427 6.85986"
                                stroke="#8F969C"
                                stroke-width="1.52381"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M11.077 11.0832H11.0845"
                                stroke="#8F969C"
                                stroke-width="1.52381"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M6.91292 6.91667H6.92042"
                                stroke="#8F969C"
                                stroke-width="1.52381"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <strong>{generatePromoCode()}</strong>
                    </div>
                </div>
                <div className="trial-total">
                    <div className="trial-total-line">
                        <span>Total:</span>
                        <strong>{total} USD</strong>
                    </div>
                    <div className="trial-total-bottom">
                        You just saved {discount} USD ({precent}% off)
                    </div>
                </div>
                {/* {selectedMethod === 'applePay' && (
                <div style={{ minHeight: "113px", margin: "24rem 0px 24rem", display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                    <div className="trial-method__amount">
                        1.00 <span>USD
                        </span>
                    </div>
                </div>
            )} */}
                <div
                    style={{
                        display: "flex",
                        flex: 1,
                        alignItems: platfrom == "iOS" ? "flex-end" : "stretch",
                        width: "100%",
                    }}
                >
                    <div
                        className={`trial-method__credit-card ${selectedMethod === "creditCard" ? "" : "hidden"
                            }`}
                        style={{ width: "100%", paddingBottom: "62rem" }}
                    >
                        <div
                            style={{
                                minHeight: "113px",
                                margin: "0 0px 24rem",
                                flex: platfrom == "iOS" ? "0" : "1",
                            }}
                        >
                            {merchantData?.paymentIntent && (
                                <Payment
                                    merchantData={merchantData}
                                    styles={styles}
                                    formParams={formParams}
                                    onReadyPaymentInstance={handleOnReadyPaymentInstance}
                                    onMounted={handleMounted}
                                    onSuccess={handleSuccess}
                                    onSubmit={(event) => handleSubmit(event, selectedMethod)}
                                    applePayContainerRef={appleContainerRef}
                                    onFail={handleFail}
                                />
                            )}
                        </div>
                        <div className="block-button">
                            <WithWizard
                                render={({ next, previous, step, steps }) => (
                                    <MyButton
                                        buttonText={"Continue"}
                                        // buttonIcon={'lock'}
                                        // onClick={next}
                                        buttonStatus={isLoadingCard ? "load" : ""}
                                        onClick={() => {
                                            // mixpanel.track("web_trial", {
                                            //     session_id: sessionId,
                                            //     web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
                                            //     user_id: localStorage.getItem('userId'),
                                            //     web_pay_method: 'CreditCard',
                                            //     web_utm_campaign: localStorage.getItem("utmCampaign"),
                                            //     web_utm_source: localStorage.getItem("utmSource"),
                                            //     web_utm_medium: localStorage.getItem("utmMedium"),
                                            //     web_utm_content: localStorage.getItem("utmContent"),
                                            //     web_utm_term: localStorage.getItem("utmTerm"),
                                            //     isDebug: false,
                                            //     funnel: process.env.REACT_APP_FUNNEL,
                                            // });
                                            // localStorage.setItem('web_pay_method', 'CreditCard')
                                            form?.submit();
                                        }}
                                    ></MyButton>
                                )}
                            />
                        </div>
                    </div>

                    <div
                        className={`trial-method__credit-card ${selectedMethod === "applePay" ? "" : "hidden"
                            }`}
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-end",
                        }}
                    >
                        {/* <div className="trial-method__amount">
        1.00 <span>USD
        </span>
    </div> */}

                        {isUSA && (
                            <div
                                onClick={() => { }}
                                style={{
                                    borderRadius: "100rem",
                                    width: "100%",
                                    overflow: "hidden",
                                    height: "62rem",
                                    position: "relative",
                                    transform: "none",
                                    marginBottom: platfrom == "iOS" ? "8rem" : "",
                                }}
                            >
                                <div
                                    id="paypal-button"
                                    style={{
                                        transform: "scale(2)",
                                        width: "100%",
                                        zIndex: "0",
                                        opacity: "1",
                                    }}
                                ></div>
                                <MyButton
                                    buttonText="Pay with"
                                    buttonIcon="PayPal"
                                    style={{
                                        position: "absolute",
                                        left: "0",
                                        top: 0,
                                        zIndex: "1",
                                        pointerEvents: "none",
                                    }}
                                // onClick={() => {
                                //     form?.submit();
                                // }}
                                ></MyButton>
                            </div>
                        )}

                        {/* <WithWizard
                            render={({ next, previous, step, steps }) => (
                                <MyButton buttonText="Pay with"
                                    buttonIcon="PayPal"
                                    onClick={next}
                                    style={{ marginBottom: '8rem', transform: 'none' }}
                                // onClick={() => {
                                //     form?.submit();
                                // }}
                                >
                                </MyButton >
                            )}
                        />
                    */}
                        {platfrom == "iOS" && (
                            <div
                                style={{ position: "relative", width: "100%", height: "62rem" }}
                            >
                                <div
                                    ref={appleContainerRef}
                                    style={{ width: "100%", opacity: "0" }}
                                ></div>
                                <MyButton
                                    style={{
                                        position: "absolute",
                                        left: "0",
                                        top: 0,
                                        zIndex: "1",
                                        pointerEvents: "none",
                                    }}
                                    buttonText="Pay with"
                                    buttonIcon="applePay"
                                // onClick={next}
                                // onClick={() => {
                                //     console.log(form)
                                //     // form?.submit();
                                // }}
                                ></MyButton>
                            </div>
                        )}

                        {/* <WithWizard
                            render={({ next, previous, step, steps }) => (
                                <MyButton buttonText="Pay with"
                                    buttonIcon="applePay"
                                    onClick={next}
                                // onClick={() => {
                                //     form?.submit();
                                // }}
                                >
                                </MyButton >
                            )}
                        /> */}
                    </div>
                </div>

                {/* <div className="trial-method__footer">
                <div className="trial-method__rating" style={{ aspectRatio: "151/54", width: '151px' }}>
                    <img src={process.env.REACT_APP_BASENAME + '/img/rating.svg'} alt="" />
                </div>

                <p className="trial-method__company-info">
                    ZEELY INC, 2810 N Church St, Ste 27833, Delaware, the USA
                </p>
            </div> */}
                {showPromocodePopup && (
                    <div className="brandname">
                        <div className="brandname-wrapper" style={{ paddingTop: "22rem" }}>
                            <div>
                                <div
                                    onClick={() => setShowPromocodePopup(false)}
                                    className="brandname-top"
                                    style={{
                                        width: "46rem",
                                        height: "46rem",
                                        marginLeft: "-14rem",
                                        marginBottom: "10rem",
                                    }}
                                >
                                    <svg
                                        style={{ width: "46rem", height: "46rem" }}
                                        width="46"
                                        height="46"
                                        viewBox="0 0 46 46"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M25.75 17L20.25 22.8182L25.75 29"
                                            stroke="black"
                                            stroke-width="1.6"
                                            stroke-linecap="round"
                                        />
                                    </svg>
                                </div>
                                <CustomTitle
                                    style={{ marginBottom: "12rem" }}
                                    title="Add your promo code"
                                />
                                <p style={{ marginBottom: "24rem" }} className="text">
                                    To make sure that your account is secured
                                </p>
                                <div className={`input `} style={{ marginBottom: "12rem" }}>
                                    <svg
                                        width="20"
                                        height="21"
                                        viewBox="0 0 20 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M8.45546 3.97842C9.06468 3.3692 9.28866 3.15262 9.54038 3.00763C9.77885 2.87027 10.0396 2.77587 10.3107 2.72872C10.5969 2.67896 10.9076 2.70196 11.7657 2.77996L13.3213 2.92138C14.0395 2.98667 14.5427 3.03284 14.9367 3.09865C15.3226 3.16311 15.5576 3.23979 15.7445 3.34373C16.1274 3.55669 16.4432 3.87248 16.6562 4.25544C16.7601 4.44234 16.8368 4.67731 16.9013 5.06325C16.9671 5.45727 17.0133 5.96041 17.0785 6.67862L17.22 8.23425C17.298 9.09228 17.321 9.403 17.2712 9.6892C17.2241 9.96033 17.1297 10.2211 16.9923 10.4596C16.8473 10.7113 16.6307 10.9352 16.0215 11.5445L11.8129 15.753C11.2113 16.3546 10.7874 16.7778 10.4297 17.0815C10.0778 17.3802 9.83303 17.5249 9.60464 17.5991C9.13266 17.7525 8.62425 17.7525 8.15226 17.5991C7.92388 17.5249 7.67908 17.3802 7.32719 17.0815C6.96949 16.7778 6.54557 16.3546 5.94396 15.753L4.2469 14.056C3.64529 13.4544 3.22209 13.0304 2.91843 12.6727C2.6197 12.3209 2.47504 12.076 2.40083 11.8477C2.24747 11.3757 2.24747 10.8673 2.40083 10.3953C2.47504 10.1669 2.61969 9.9221 2.91843 9.57021C3.22209 9.21252 3.64529 8.78859 4.2469 8.18698L8.45546 3.97842Z"
                                            stroke={error ? "#EF2C4F" : "#CAD4DD"}
                                            stroke-width="1.3"
                                        />
                                        <circle
                                            cx="11.707"
                                            cy="8.2932"
                                            r="1.5"
                                            transform="rotate(45 11.707 8.2932)"
                                            fill={error ? "#EF2C4F" : "#CAD4DD"}
                                        />
                                    </svg>

                                    <input
                                        type="text"
                                        placeholder="Enter promo code"
                                        value={promocode}
                                        onChange={handleInputChange}
                                        style={{
                                            paddingLeft: "46rem",
                                            borderColor: error ? "#EF2C4F" : "",
                                        }}
                                        className={` ${error ? "error" : ""}`}
                                    />
                                </div>
                                {/* {errorAi && (
             <div className="error-text">Error</div>
         )} */}

                                <WithWizard
                                    render={({ next, previous, step, steps }) => (
                                        <>
                                            <MyButton
                                                // ref={nextPageButtonRef}
                                                // ref={clickedElementRef}
                                                style={{ marginTop: "24rem" }}
                                                buttonStatus={buttonStatus}
                                                buttonTime={"0"}
                                                buttonText={"Continue"}
                                                onClick={() => handleClick()}
                                                className={
                                                    areAllCheckboxesUnchecked()
                                                        ? error
                                                            ? "error"
                                                            : "disable"
                                                        : undefined
                                                }
                                            ></MyButton>
                                        </>
                                    )}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {showErrors && (
                    <div className="congrats" style={{ zIndex: "2" }}>
                        <div className="congrats-icon">
                            <svg
                                width="44"
                                height="44"
                                viewBox="0 0 44 44"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect width="44" height="44" rx="22" fill="#EF2C4F" />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M24.4271 12C25.5189 11.999 26.5664 12.4318 27.3392 13.2032L30.7873 16.6451C31.56 17.4165 31.9947 18.4632 31.9956 19.5551L32 24.4271C32.001 25.5189 31.5682 26.5664 30.7968 27.3392L27.3549 30.7873C26.5835 31.56 25.5368 31.9947 24.4449 31.9956L19.5729 32C18.4811 32.001 17.4336 31.5682 16.6608 30.7968L13.2127 27.3549C12.44 26.5835 12.0053 25.5368 12.0044 24.4449L12 19.5729C11.999 18.4811 12.4318 17.4336 13.2032 16.6608L16.6451 13.2127C17.4165 12.44 18.4632 12.0053 19.5551 12.0044L24.4271 12ZM20.5881 17.2474C20.5403 16.435 21.1862 15.75 22 15.75C22.8138 15.75 23.4597 16.435 23.4119 17.2474L23.0587 23.2517C23.0257 23.8123 22.5615 24.25 22 24.25C21.4385 24.25 20.9743 23.8123 20.9413 23.2517L20.5881 17.2474ZM22 25.25C21.1716 25.25 20.5 25.9216 20.5 26.75C20.5 27.5784 21.1716 28.25 22 28.25C22.8284 28.25 23.5 27.5784 23.5 26.75C23.5 25.9216 22.8284 25.25 22 25.25Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <div className="congrats-info">
                            <strong>Oops, something went wrong</strong>
                            <span>We were unable to make the payment </span>
                        </div>
                    </div>
                )}
            </div></>
    );
};

export default Trial;
